export default () => {
    let favicon = '';
    const host = window.location.host;
    if (host.indexOf('dianping') > -1 || host.indexOf('51ping') > -1) {
        favicon = '//www.dpfile.com/s/res/favicon.5ff777c11d7833e57e01c9d192b7e427.ico';
    } else if (host.indexOf('meituan') > -1) {
        favicon = '//p1.meituan.net/codeman/44f8f3736d61a550dc0fa7bc1a70b6056518.ico';
    }
    if (favicon) {
        let head = document.getElementsByTagName('head')[0],
            linkTag = document.createElement('link');
        linkTag.href = favicon;
        linkTag.setAttribute('rel','Shortcut Icon');
        linkTag.setAttribute('type','image/x-icon');
        head.appendChild(linkTag);
    }
};



// WEBPACK FOOTER //
// ./src/lib/favicon.js